import { css } from '@emotion/core'

export const cssMiniMapWrapper = css`
  background-color: transparent;
  block-size: 178px;
  border: none;
  inline-size: 100%;
  margin: 20px 0 10px 0;
  position: relative;
`

export const cssExpandButton = css`
  inset-block-start: 10px;
  inset-inline-end: 10px;
  position: absolute;
  z-index: 1;
`
